import stringify from "json-stable-stringify";

export const CACHE_USAGE_KEY = "RW.Api.CacheUsageStats";

export interface CacheUsageStats {
  url: string;
  origin: string;
  usageCount: number;
}

export const loadCacheUsageStats = (): CacheUsageStats[] => {
  try {
    const storedData = localStorage.getItem(CACHE_USAGE_KEY);
    return storedData ? JSON.parse(storedData) : [];
  } catch (error) {
    console.error("Failed to load cache usage from localStorage:", error);
    return [];
  }
};

export const incrementCacheUsageStats = (requestToUrl: string) => {
  try {
    const cacheUsageStats = loadCacheUsageStats();
    const originUrl = getUrlWithFirstSegment();
    const existingCacheUsage = cacheUsageStats.find((cu) => cu.url === requestToUrl && cu.origin === originUrl);

    if (existingCacheUsage) {
      existingCacheUsage.usageCount++;
    } else {
      cacheUsageStats.push({ url: requestToUrl, origin: originUrl, usageCount: 1 });
    }

    saveCacheUsageStats(cacheUsageStats);
  } catch (error) {
    console.error("Failed to save cache usage to localStorage:", error);
  }
};

export const saveCacheUsageStats = (cacheUsage: CacheUsageStats[]) => {
  try {
    const cacheUsageEntriesString = stringify(cacheUsage);

    if (cacheUsageEntriesString) {
      localStorage.setItem(CACHE_USAGE_KEY, cacheUsageEntriesString);
    }
  } catch (error) {
    console.error("Failed to save cache usage to localStorage:", error);
  }
};

export const clearCacheUsageStats = () => {
  try {
    localStorage.removeItem(CACHE_USAGE_KEY);
  } catch (error) {
    console.error("Failed to clear cache usage from localStorage:", error);
  }
}

const getUrlWithFirstSegment = () => {
  const { origin, pathname } = new URL(window.location.href);
  const firstSegment = pathname.split('/')[1];
  return firstSegment ? `${origin}/${firstSegment}` : origin;
};